import React from "react";
import { MakeType } from "../types";
import { useTranslation } from "react-i18next";

interface Props {
  makeType: MakeType;
  onMakePay: () => void;
  onMakePromotion: () => void;
  // onMakeTrial: () => void;
}

const SectionWrapper: React.FC<{
  title: string;
  sub: string;
  children?: React.ReactNode;
}> = ({ title, sub, children }) => (
  <div className="site" style={{ marginTop: 20 }}>
    <div className="trialApply">
      <div className="image-wait" />
    </div>
    <h3 className="site__title" style={{ marginTop: 20, fontSize: 16 }}>
      {title}
    </h3>
    <p className="site__desc">{sub}</p>
    {children}
  </div>
);

const ServiceCreationStates = ({
  makeType,
  onMakePay,
  onMakePromotion,
}: // onMakeTrial,
Props) => {
  const { t } = useTranslation();
  if (makeType === "T_APPLY") {
    return (
      // 무료 체험 신청이 접수되었습니다.
      <SectionWrapper
        title={t("siteType.complete.title")}
        sub={t("siteType.complete.subTitle")}
      />
    );
  }

  if (makeType === "MAKE_PAY") {
    // 결제가 완료되었습니다. 사이트를 생성해주세요.
    return (
      <SectionWrapper
        title={t("siteType.paymentSuccess")}
        sub={t("siteManagement.free.afterApplication.subTitle")}
      >
        <div className="createButton">
          <button type="button" onClick={onMakePay} className="btn btn-green">
            <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
            {t("siteManagement.createBtn")}
          </button>
        </div>
      </SectionWrapper>
    );
  }

  if (makeType === "MAKE_PROMOTION") {
    // 신청이 승인되었습니다. 사이트를 생성해주세요.
    return (
      <SectionWrapper
        title={t("siteManagement.free.afterApplication.title")}
        sub={t("siteManagement.free.afterApplication.subTitle")}
      >
        <div className="createButton">
          <button
            type="button"
            onClick={onMakePromotion}
            className="btn btn-green"
          >
            <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
            {t("siteManagement.createBtn")}
          </button>
        </div>
      </SectionWrapper>
    );
  }

  if (makeType === "C_APPLY") {
    // 프리미엄 요금제 문의가 접수되었습니다.
    return (
      <SectionWrapper
        title={t("siteType.promotionApply.title")}
        sub={t("siteType.promotionApply.subTitle")}
      />
    );
  }

  // 승인 완료 후 무료 사이트 생성 버튼
  if (makeType === "T_APPROVED") {
    // 신청이 승인되었습니다. 사이트를 생성해주세요.
    return (
      <div className="site" style={{ marginTop: 20 }}>
        <div className="trialApply">
          <div className="image-done" />
        </div>
        <h3 className="site__title" style={{ marginTop: 20, fontSize: 16 }}>
          {t("siteManagement.free.afterApplication.title")}
        </h3>
        <p className="site__desc">
          {t("siteManagement.free.afterApplication.subTitle")}
        </p>
        <div className="createButton">
          {/* 무료 체험 관련 로직 추후 개발 */}
          {/* <button type="button" onClick={onMakeTrial} className="btn btn-green"> */}
          <button type="button" className="btn btn-green">
            <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
            {t("siteManagement.createBtn")}
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default ServiceCreationStates;
